(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expense-type', {
            parent: 'entity',
            url: '/expense-type?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'wamasysApp.expenseType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense-type/expense-types.html',
                    controller: 'ExpenseTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expenseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('expense-type-detail', {
            parent: 'entity',
            url: '/expense-type/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.expenseType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/expense-type/expense-type-detail.html',
                    controller: 'ExpenseTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExpenseType', function($stateParams, ExpenseType) {
                    return ExpenseType.get({id : $stateParams.id});
                }]
            }
        })
        .state('expense-type.new', {
            parent: 'expense-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-dialog.html',
                    controller: 'ExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('expense-type');
                });
            }]
        })
        .state('expense-type.edit', {
            parent: 'expense-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-dialog.html',
                    controller: 'ExpenseTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExpenseType', function(ExpenseType) {
                            return ExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('expense-type.delete', {
            parent: 'expense-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/expense-type/expense-type-delete-dialog.html',
                    controller: 'ExpenseTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExpenseType', function(ExpenseType) {
                            return ExpenseType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
